/**
 * @fileoverview POST handler for the "/engagement/query_builder/:app_group_id/:report_id/schedule" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementQueryBuilderAppGroupIdReportIdScheduleCacheKeys } from "./constants";
import type {
  EngagementQueryBuilderAppGroupIdReportIdScheduleResult,
  PostEngagementQueryBuilderAppGroupIdReportIdScheduleProps,
} from "./types";

export const postEngagementQueryBuilderAppGroupIdReportIdSchedule = reactQueryMutationAdapter(
  engagementQueryBuilderAppGroupIdReportIdScheduleCacheKeys,
  (
    props: PostEngagementQueryBuilderAppGroupIdReportIdScheduleProps
  ): Promise<EngagementQueryBuilderAppGroupIdReportIdScheduleResult> => {
    return fetch(
      `/engagement/query_builder/${props.appGroupId}/${props.reportId}/schedule`,
      "POST",
      props.report,
      undefined,
      {
        propagateFetchRequestError: true,
      }
    );
  }
);
